import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { images } from '../mock';
import { Wheat, Sprout, Beaker, CheckCircle } from 'lucide-react';

const Trading = () => {
  const { t } = useLanguage();

  const productIcons = [Wheat, Sprout, Beaker];

  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="relative py-20 min-h-[60vh] flex items-center">
        {/* Background Image */}
        <div className="absolute inset-0 z-0">
          <img
            src="https://images.unsplash.com/photo-1714168526009-2d0d333640d5"
            alt="Agricultural Trading"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#003840]/65 via-[#003840]/55 to-[#003840]/65"></div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 animate-float">
              {t.trading.title}
            </h1>
            <p className="text-xl text-gray-100 max-w-3xl mx-auto leading-relaxed animate-fade-in">
              {t.trading.subtitle}
            </p>
          </div>
        </div>
      </section>

      {/* Intro Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center">
            <p className="text-lg text-gray-600 leading-relaxed">
              {t.trading.intro}
            </p>
          </div>
        </div>
      </section>

      {/* Product Categories */}
      <section className="py-20 bg-[#F4F7F6]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-[#003840] mb-4">
              {t.trading.products.title}
            </h2>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            {t.trading.products.items.map((product, index) => {
              const Icon = productIcons[index];
              return (
                <div
                  key={index}
                  className="bg-white border-2 border-gray-100 rounded-2xl overflow-hidden hover:border-[#007369] hover:shadow-2xl transition-all duration-300 group"
                >
                  <div className="h-56 overflow-hidden">
                    <img
                      src={images.trading.products[index]}
                      alt={product.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                    />
                  </div>
                  <div className="p-6">
                    <div className="flex items-center gap-3 mb-4">
                      <div className="p-3 bg-[#F4F7F6] rounded-lg">
                        <Icon className="h-6 w-6 text-[#007369]" />
                      </div>
                      <h3 className="text-2xl font-bold text-[#003840]">{product.title}</h3>
                    </div>
                    <p className="text-gray-600 leading-relaxed">{product.description}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Trading Approach */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-[#003840] mb-4">
              {t.trading.approach.title}
            </h2>
          </div>

          <div className="max-w-3xl mx-auto">
            <div className="bg-[#F4F7F6] rounded-2xl shadow-lg p-8">
              <div className="space-y-4">
                {t.trading.approach.items.map((item, index) => (
                  <div key={index} className="flex items-start gap-4 p-4 bg-white rounded-lg transition-all hover:shadow-md">
                    <CheckCircle className="h-6 w-6 text-[#007369] flex-shrink-0 mt-1" />
                    <span className="text-lg text-gray-700">{item}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-[#003840] text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            {t.cta.trading.title}
          </h2>
          <p className="text-xl text-gray-300 mb-8">
            {t.cta.trading.subtitle}
          </p>
        </div>
      </section>
    </div>
  );
};

export default Trading;